const SECONDS_IN_ONE_YEAR = 31536000;

function numberEnding(number) {
  return number > 1 ? 's' : '';
}

export function millisecondsToStr(milliseconds) {
  // TIP: to find current time in milliseconds, use:
  // var  current_time_milliseconds = new Date().getTime();
  var temp = Math.floor(Math.abs(milliseconds) / 1000);
  var years = Math.floor(temp / SECONDS_IN_ONE_YEAR);
  if (years) {
    return years + ' year' + numberEnding(years);
  }
  //TODO: Months! Maybe weeks?
  let duration = (temp %= 31536000) / 86400;
  var days = Math.floor(duration);
  let hours = Math.floor((duration - days) * 24);
  if (days) {
    return (
      days +
      ' day' +
      numberEnding(days) +
      (days > 0 ? ` ${hours} hour${numberEnding(hours)}` : '')
    );
  }
  duration = (temp %= 86400) / 3600;
  hours = Math.floor(duration);
  let minutes = Math.floor((duration - hours) * 60);
  if (hours) {
    return (
      hours +
      ' hour' +
      numberEnding(hours) +
      (minutes > 0 ? ` ${minutes} minute${numberEnding(minutes)}` : '')
    );
  }
  minutes = Math.floor((temp %= 3600) / 60);
  if (minutes) {
    return minutes + ' minute' + numberEnding(minutes);
  }
  var seconds = temp % 60;
  if (seconds) {
    return seconds + ' second' + numberEnding(seconds);
  }
  return 'less than a second'; //'just now' //or other string you like;
}

export const startsIn = (epoch) => {
  const currentDate = new Date();
  const eventDate = new Date(Number(epoch));

  const delta = eventDate - currentDate;
  if (delta >= 0) {
    return 'Started';
  }
  return `Starts in ${millisecondsToStr(delta)}`;
};

export const isTimeBetween = (startUTCEpoch, endUTCEpoch) => {
  const startDate = new Date(Number(startUTCEpoch));
  const endDate = new Date(Number(endUTCEpoch));
  const currentDate = new Date();

  const startDateDelta = currentDate - startDate;
  const endDateDelta = currentDate - endDate;
  return startDateDelta > 0 && endDateDelta < 0;
};

export const isTimeAfter = (epoch) => {
  const date = new Date(Number(epoch));
  const currentDate = new Date();

  const timeDelta = currentDate - date;
  return timeDelta > 0;
};

export const calculateStatus = (submissionStart, submissionEnd, endPeriod) => {
  const now = new Date();
  const msToStart = submissionStart - now.getTime();
  const msToEnd = endPeriod - now.getTime();
  // Contract not configured
  if (0 === Number(submissionStart + submissionEnd + endPeriod)) {
    return 'Soon';
  }
  if (isTimeBetween(submissionStart, submissionEnd)) {
    return `${millisecondsToStr(submissionEnd - now.getTime())}`;
  }
  if (msToStart > 0) {
    // const startsIn = new Date(Number(endPeriod)) - new Date();
    return `${millisecondsToStr(msToStart)}`;
  } else if (msToEnd > 0) {
    return `${millisecondsToStr(msToEnd)}`;
  } else {
    return `-`;
  }
};

export const calculateDuration = (startPeriod, endPeriod) => {
  const delta = new Date(Number(endPeriod)) - new Date(Number(startPeriod));
  return millisecondsToStr(delta);
};

export function daysToSeconds(days) {
  return days * 24 * 60 * 60;
}

export function secondsToDays(seconds) {
  return seconds / 60 / 60 / 24;
}

export function secondsToMilliseconds(seconds) {
  return seconds * 1000;
}

export function secondsToDate(seconds) {
  return new Date(secondsToMilliseconds(seconds));
}
